let html = `<div class="player-video">
    <div class="player-video__display"></div>
    <div class="player-video__loader"></div>
    <div class="player-video__paused hide">
        <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="6" height="25" rx="2" fill="white"/>
            <rect x="13" width="6" height="25" rx="2" fill="white"/>
        </svg>
    </div>
    <div class="player-video__backwork-icon">
        <i class="left-triangle triangle">◀◀◀</i><span></span>
    </div>
    <div class="player-video__forward-icon">
        <span></span><i class="right-triangle triangle">▶▶▶</i>
    </div>
    <div class="player-video__subtitles hide">
        <div class="player-video__subtitles-text"></div>
    </div>
</div>`

export default html